import styled from 'styled-components'

export const NewSupplierContent = styled.div``
